module.exports = __webpack_public_path__ + "img/home-dog-4.112f4837.jpg";